import { useIntl } from 'react-intl';
import { z } from 'zod';

import { getPlainTextLength } from '@/utils/string-util';

import { MIN_JOB_DESCRIPTION_LENGTH } from './constants';

/**
 * Hook to create the validation schema for job details (title and description)
 */
export function useJobDetailsSchema() {
  const intl = useIntl();

  const messages = {
    titleRequired: intl.formatMessage({
      defaultMessage: 'Title is required',
      description: 'Title input required error message',
    }),
    descriptionRequired: intl.formatMessage({
      defaultMessage: 'Description is required',
      description: 'Description input required error message',
    }),
    descriptionMinLength: intl.formatMessage({
      defaultMessage: 'Description must be at least 250 characters long',
      description: 'Description input validation error message',
    }),
  };

  return z.record(
    z.string(),
    z.object({
      title: z.string().min(1, {
        message: messages.titleRequired,
      }),
      description: z
        .string()
        .min(1, {
          message: messages.descriptionRequired,
        })
        .refine(
          (val: string) =>
            getPlainTextLength(val) >= MIN_JOB_DESCRIPTION_LENGTH,
          {
            message: messages.descriptionMinLength,
          },
        ),
    }),
  );
}
